export default "__VITE_ASSET__BsgksJBa__"